import { FC, Fragment, MouseEventHandler } from "react";
import { ImgRounded } from "../atoms/ImgRounded";
import { DateTime } from "luxon";
import { classNames } from "@/shared/utils/classnames";

export type MessageItemProps = {
  isLoading?: boolean;
  message?: any;
  onClick?: MouseEventHandler;
  user: any;
};

export const MessageItem: FC<MessageItemProps> = ({
  message,
  isLoading,
  onClick,
  user,
}) => {
  return (
    <div
      className={classNames(
        "flex",
        message.senderId == user.id ? "justify-end" : "justify-start"
      )}
    >
      <div
        className={classNames(
          "flex flex-col rounded-md p-2 shadow-md max-w-[50%] gap-2 break-words",
          message.senderId == user.id
            ? "bg-primary-500 text-white"
            : "bg-white text-black",
          message.chateable.isFile ? "w-2/4" : ""
        )}
      >
        {message.chateable.isFile ? (
          <img src={message.chateable.src} className="rounded-sm" />
        ) : (
          <span>{message.chateable.content}</span>
        )}
        <p className="text-[0.7rem]">
          {DateTime.fromISO(message.chateable.createdAt).toFormat(
            "dd-MM-yyyy HH:mm"
          )}
        </p>
      </div>
    </div>
  );
};
